import { getSvgOfDashStyle, loadStyle } from "@euroland/react-high-chart";
import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { CHART_PATTERN, SERIES_LINE_CHART_TYPE, TOOL_TEMPLATE } from "../../constant/common";
import { useTemplateSetting } from "../../hooks/useCompanySettings";
import { colorBlindModeSelector } from "../../store/slice/settings";
import i18n from "../../locale/i18n";
import { dividendDataSelector } from "../../store/slice/trade";

function TickerLengendMultipleLineChart({ series = [], instrumentDataAndSetting = {}, chartRef }) {
  const colorBlind = useSelector(colorBlindModeSelector);
  const template = useTemplateSetting();
  const isVictor = template === TOOL_TEMPLATE.victor;
  const dividendData = useSelector(dividendDataSelector);

  const [legends, setLegend] = useState([]);

  useEffect(() => {
    if (!!chartRef.current?.container?.current) {
      const styleSeries = [];
      series.forEach(item => {
        const instrument = instrumentDataAndSetting[item.instrumentId];
        const hasDividend = series.some(s => s.id === SERIES_LINE_CHART_TYPE.TOTAL_RETURN);
        let color = "";
        let dashStyle =
          colorBlind && item.id === SERIES_LINE_CHART_TYPE.TOTAL_RETURN
            ? CHART_PATTERN.SHORT_DASH
            : CHART_PATTERN.SOLID;

        if (isVictor) {
          switch (item.id) {
            case SERIES_LINE_CHART_TYPE.VALUE:
              color = instrument.setting.color || loadStyle(
                chartRef.current.container.current,
                "--chart-line-color-value", "#2F80ED"
              ).get();
              break;
            default:
              color = loadStyle(
                chartRef.current.container.current,
                "--chart-line-color-total",
                "#F2994A"
              ).get();
              break;
          }
        }
        // quadrata
        else {
          switch (item.id) {
            case SERIES_LINE_CHART_TYPE.VALUE:
              color = hasDividend
                ? instrument.setting.color || loadStyle(
                    chartRef.current.container.current,
                    "--chart-line-color-value","#11A55E"
                  ).get()
                : loadStyle(chartRef.current.container.current, "--chart-line-color-total", "#404D61").get();
              break;
            default:
              color = hasDividend
                ? loadStyle(chartRef.current.container.current, "--chart-line-color-total", "#404D61").get()
                : loadStyle(
                    chartRef.current.container.current,
                    "--chart-line-color-value",
                    instrument.setting.color || "#11A55E"
                  ).get();
              break;
          }





        }
        styleSeries.push({
          name: i18n.translate(item.id),
          dashStyle,
          color,
        });
      });
      setLegend(styleSeries);
    }
  }, [series, colorBlind]);

  if (colorBlind && dividendData) {
    return (
      <ul className="legend-chart">
        {legends.map((item, index) => {
          return (
            <li className="legend-chart__item" key={index}>
              {getSvgOfDashStyle({
                lineWidth: 3,
                color: item.color,
                dashStyle: item.dashStyle,
                isReactComponent: true,
              })}
              <p className="legend-chart__text">{item.name}</p>
            </li>
          );
        })}
      </ul>
    );
  } else {
    return <></>
  }
}

export default TickerLengendMultipleLineChart;
